import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Spin, Input } from 'antd';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Captcha from 'react-captcha-code';

import './verificationCodeModal.css'

const VerificationCodeModal = (props) => {

    let timer = useRef();
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [form] = Form.useForm();
    const messageRef = useRef();
    const [resendTime, setResendTime] = useState("");
    const [isLoad, setIsLoad] = useState(false);
    const [partnerModel, setPartnerModel] = useState(props.partnerModel)
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnContent, setBtnContent] = useState('Send');
    const [code, setCode] = useState("");
    const captchaRef = useRef(null);

    useEffect(() => {
        searchResendTime();
    }, []);

    const searchResendTime = () => {
        messageShowHandler();
        setIsLoad(true);
        Base.callBackApi("partnerDetail/searchResendTime").then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object
                setResendTime(model.resendTime);
                sendEmail(model.resendTime)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const sendEmail = (time) => {
        messageShowHandler();
        let model = { userCode: partnerModel.partnerContactAcctId }
        setIsLoad(true);
        Base.callBackApi("partnerDetail/sendCode", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!time) {
                    errFrameShow("success", 'Verification Code sent successfully.');
                    countDownFunc(resendTime);
                } else {
                    countDownFunc(time);
                }
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const checkSmsCode = (values) => {
        messageShowHandler();
        if (code !== values.code) {
            errFrameShow("error", "Invalid captcha.");
            captchaRef.current.refresh();
            return
        }
        values.userCode = partnerModel.partnerContactAcctId
        setIsLoad(true);
        Base.callBackApi("partnerDetail/checkSmsCode", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object
                props.onClose(true, model.smsCode)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const countDownFunc = (time) => {
        setBtnDisabled(true);
        setBtnContent(`Resend ${time}s`);
        timer.current = setInterval(() => {
            time--;
            setBtnContent(`Resend ${time}s`);
            if (time === 0) {
                setBtnDisabled(false);
                setBtnContent('Send');
                clearInterval(timer.current);
            }
        }, 1000);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleChange = (code) => {
        setCode(code);
    }

    const handleClick = () => {
        captchaRef.current.refresh();
    }

    return (
        <Modal
            visible={isModalVisible}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='740px'//弹框宽度
            footer={false}
            style={{ minWidth: '400px' }}
        >
            <div className='verificationCodeModal'>
                <Message ref={messageRef} />
                <Spin spinning={isLoad}>
                    <Form form={form} onFinish={checkSmsCode}>
                        <div className='title'>Please enter the verification code send to your old email address</div>
                        <Form.Item
                            name="smsCode"
                        >
                            <div className='loginFlexBox'>
                                <span>Code</span>
                                <Input maxLength={100} style={{ backgroundColor: '#FFFFFF' }} className="loginInput" placeholder="Code" />
                                <Button className="sysBtn loginSendButton" onClick={() => sendEmail()} disabled={btnDisabled}>{btnContent}</Button>
                            </div>
                        </Form.Item>
                        <Form.Item
                            name="code"
                        >
                            <div className='loginFlexBox'>
                                <Input maxLength={100} style={{ backgroundColor: '#FFFFFF' }} className="loginInput" placeholder="Captcha" />
                                <Captcha ref={captchaRef} onChange={handleChange} onClick={handleClick} />
                            </div>
                        </Form.Item>
                        <div className='confirmButtonRow'>
                            <Button className="sysBtn btnBlue loginSendButton" type="primary" htmlType="submit" icon={<CheckOutlined />} disabled={isLoad}>Confirm</Button>
                            <Button className="sysBtn loginSendButton" onClick={() => props.onClose(false)} icon={<CloseOutlined />}>Cancel</Button>
                        </div>
                    </Form>
                </Spin>
            </div>
        </Modal>
    )
}

VerificationCodeModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    partnerModel: PropTypes.object.isRequired,
}
export default VerificationCodeModal;